import styled from 'styled-components';

export const ContainerStyled = styled.div`
  border-radius: 8px;
  border: 1px solid var(--ds-border, var(--ds-fb-border));

  display: flex;
  flex-direction: column;
`;

export const HeaderStyled = styled.div`
  flex: 1 56px;

  display: flex;
  align-items: center;
`;

export const BodyStyled = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FooterStyled = styled.div`
  flex: 1 56px;

  display: flex;
  align-items: center;
  justify-content: end;
`;

export const NameStyled = styled.div`
  font-size: 14px;
  font-weight: 600;
  min-width: 100px;
  flex: 1 500px;

  padding-right: 32px;
`;

export const ContentTextStyled = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: var(--ds-text-subtlest, var(--ds-fb-text-subtlest));
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
`;

export const FolderIconStyled = styled.div`
  padding-left: 32px;
  padding-right: 10px;
`;

export const ChevronButtonStyled = styled.div`
  padding-right: 10px;
  padding-left: 10px;
`;
